// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden {
  margin-left: -200px;
}

a[data-toggle='collapse'] {
  position: relative;
}

@media (max-width: 575px) {
  .hidden {
    margin-left: 0;
  }
}

.sidebar-header {
  padding: 20px;
}

ul li a {
  padding: 15px;
  /* display: block; */
  display: flex;
  width: 100%;
  /* &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  } */
}

hr {
  border-top: 1px solid #fff;
  margin-top: 0;
}
/**tabbar left navigation starts**/

li {
  display: block;
  padding: 0 5px 0 0;
}
li > a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #222b45;
  border-bottom: 1px solid #edf1f7;
  position: relative;
  font-family: 'montserratregular', Arial, Helvetica, sans-serif;
  font-weight: normal;
  padding: 14px 25px 14px 15px;
}
li:last-child > a {
  border-bottom-color: transparent;
}
li:hover > a,
li:hover > a > i {
  color: #36f;
  cursor: pointer;
}
li > a.active,
li > a.active > i {
  color: #36f;
}
li > a.active::before {
  content: '';
  width: 3px;
  height: 100%;
  background-color: #7f8dff;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
}
li > a > span {
  display: block;
  font-size: 0.9rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: normal;
}
li > a > i {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  margin-right: 10px;
  width: 20px;
  color: #828c9f;
}
li:hover ul {
  background-color: rgba(0, 0, 0, 0.01);
}
li.hasSubMenu > a:after {
  content: '\\e908';
  display: inline-block;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  font-family: 'icomoon';
  font-weight: normal;
  font-size: 0.7rem;
  transition: all 0.2s ease-out;
}

li.hasSubMenu > a.selected:after {
  content: '\\f078';
  display: inline-block;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  font-family: 'FontAwesome';
  font-weight: normal;
  font-size: 0.7rem;
  transition: all 0.2s ease-out;
}

li.hasSubMenu > a.activeTab:after {
  transform: translateY(-50%) rotate(90deg);
}
/* li.hasSubMenu ul {
  display: none;
} */
li.hasSubMenu > ul li {
  padding: 0;
}
li.hasSubMenu > ul li > a {
  padding-left: 30px;
  color: #617d95;
}
li.hasSubMenu > ul li > a:hover {
  color: #36f;
}
li.hasSubMenu > ul > li.hasSubMenu > ul {
  position: fixed;
  top: 400px;
  left: 235px;
  z-index: 99;
  box-shadow: 0 7px 18px -8px #000;
  -webkit-box-shadow: 0 7px 18px -8px #000;
  -moz-box-shadow: 0 7px 18px -8px #000;
  background-color: #fff;
  overflow: hidden;
  overflow-y: auto;
}
li.hasSubMenu > ul > li.hasSubMenu > ul > li > a {
  color: #153d77;
}
li.hasSubMenu > ul > li.hasSubMenu > ul.active {
  display: block;
  background-color: #f2f2f2;
}
.menuClosed .leftNav {
  margin-left: -250px;
}
.leftNavActionbar {
  height: 45px;
  overflow: hidden;
  position: relative;
  z-index: 2;
}
.leftNavActionbar a {
  background-color: #8f9bb3;
  color: #fff;
  padding: 10px 15px;
  height: 45px;
  display: flex;
  width: 100%;
}
/**tabbar left navigation ends**/

@media (max-width: 767px) {
  .leftNav {
    position: fixed;
    top: 50px;
    z-index: 98;
    height: calc(100% - 50px);
  }
}
.btnToggleBlock {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 10px;
  /* background-color: #f2f5ff; */
  color: #ffffff;
  cursor: pointer;
  z-index: 2;
  font-size: 0.6rem;
}

.profileContent .block > h4 {
  border-bottom: none !important;

  padding-bottom: 0px !important
   ;
}

.leftNav .userSetting ul.lnUl li > a {
  border-bottom: 1px solid;
  border-image-slice: 1;
  border-width: 1px;
  border-image-source: linear-gradient(to left, #1bd2f7, #c0eef7);
}

.signout {
  background: linear-gradient(to left, #1bd2f7, #c0eef7);
}
@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {
  .leftNav {
    width: 170px;
  }
}

li.hasSubMenu > ul li ul li > a {
  padding-left: 38px !important;
}

li.hasSubMenu > ul li ul li > a > span,
li.hasSubMenu > ul li ul li > a > i {
  font-size: 0.85rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/system-common/menu-item/menu-item.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX;;KAEG;AACL;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;AACA,kCAAkC;;AAElC;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,8DAA8D;EAC9D,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;AACA;;GAEG;AACH;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;AACb;AACA,gCAAgC;;AAEhC;EACE;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,yBAAyB;EAC3B;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;;EAE9B;GACC;AACH;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,+DAA+D;AACjE;;AAEA;EACE,sDAAsD;AACxD;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;AACpB","sourcesContent":[".hidden {\r\n  margin-left: -200px;\r\n}\r\n\r\na[data-toggle='collapse'] {\r\n  position: relative;\r\n}\r\n\r\n@media (max-width: 575px) {\r\n  .hidden {\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n.sidebar-header {\r\n  padding: 20px;\r\n}\r\n\r\nul li a {\r\n  padding: 15px;\r\n  /* display: block; */\r\n  display: flex;\r\n  width: 100%;\r\n  /* &:hover {\r\n    background-color: rgba(255, 255, 255, 0.1);\r\n  } */\r\n}\r\n\r\nhr {\r\n  border-top: 1px solid #fff;\r\n  margin-top: 0;\r\n}\r\n/**tabbar left navigation starts**/\r\n\r\nli {\r\n  display: block;\r\n  padding: 0 5px 0 0;\r\n}\r\nli > a {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  color: #222b45;\r\n  border-bottom: 1px solid #edf1f7;\r\n  position: relative;\r\n  font-family: 'montserratregular', Arial, Helvetica, sans-serif;\r\n  font-weight: normal;\r\n  padding: 14px 25px 14px 15px;\r\n}\r\nli:last-child > a {\r\n  border-bottom-color: transparent;\r\n}\r\nli:hover > a,\r\nli:hover > a > i {\r\n  color: #36f;\r\n  cursor: pointer;\r\n}\r\nli > a.active,\r\nli > a.active > i {\r\n  color: #36f;\r\n}\r\nli > a.active::before {\r\n  content: '';\r\n  width: 3px;\r\n  height: 100%;\r\n  background-color: #7f8dff;\r\n  z-index: 2;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n}\r\nli > a > span {\r\n  display: block;\r\n  font-size: 0.9rem;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  line-height: normal;\r\n}\r\nli > a > i {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 1.2rem;\r\n  margin-right: 10px;\r\n  width: 20px;\r\n  color: #828c9f;\r\n}\r\nli:hover ul {\r\n  background-color: rgba(0, 0, 0, 0.01);\r\n}\r\nli.hasSubMenu > a:after {\r\n  content: '\\e908';\r\n  display: inline-block;\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 15px;\r\n  transform: translateY(-50%);\r\n  font-family: 'icomoon';\r\n  font-weight: normal;\r\n  font-size: 0.7rem;\r\n  transition: all 0.2s ease-out;\r\n}\r\n\r\nli.hasSubMenu > a.selected:after {\r\n  content: '\\f078';\r\n  display: inline-block;\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 15px;\r\n  transform: translateY(-50%);\r\n  font-family: 'FontAwesome';\r\n  font-weight: normal;\r\n  font-size: 0.7rem;\r\n  transition: all 0.2s ease-out;\r\n}\r\n\r\nli.hasSubMenu > a.activeTab:after {\r\n  transform: translateY(-50%) rotate(90deg);\r\n}\r\n/* li.hasSubMenu ul {\r\n  display: none;\r\n} */\r\nli.hasSubMenu > ul li {\r\n  padding: 0;\r\n}\r\nli.hasSubMenu > ul li > a {\r\n  padding-left: 30px;\r\n  color: #617d95;\r\n}\r\nli.hasSubMenu > ul li > a:hover {\r\n  color: #36f;\r\n}\r\nli.hasSubMenu > ul > li.hasSubMenu > ul {\r\n  position: fixed;\r\n  top: 400px;\r\n  left: 235px;\r\n  z-index: 99;\r\n  box-shadow: 0 7px 18px -8px #000;\r\n  -webkit-box-shadow: 0 7px 18px -8px #000;\r\n  -moz-box-shadow: 0 7px 18px -8px #000;\r\n  background-color: #fff;\r\n  overflow: hidden;\r\n  overflow-y: auto;\r\n}\r\nli.hasSubMenu > ul > li.hasSubMenu > ul > li > a {\r\n  color: #153d77;\r\n}\r\nli.hasSubMenu > ul > li.hasSubMenu > ul.active {\r\n  display: block;\r\n  background-color: #f2f2f2;\r\n}\r\n.menuClosed .leftNav {\r\n  margin-left: -250px;\r\n}\r\n.leftNavActionbar {\r\n  height: 45px;\r\n  overflow: hidden;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n.leftNavActionbar a {\r\n  background-color: #8f9bb3;\r\n  color: #fff;\r\n  padding: 10px 15px;\r\n  height: 45px;\r\n  display: flex;\r\n  width: 100%;\r\n}\r\n/**tabbar left navigation ends**/\r\n\r\n@media (max-width: 767px) {\r\n  .leftNav {\r\n    position: fixed;\r\n    top: 50px;\r\n    z-index: 98;\r\n    height: calc(100% - 50px);\r\n  }\r\n}\r\n.btnToggleBlock {\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 6px 10px;\r\n  /* background-color: #f2f5ff; */\r\n  color: #ffffff;\r\n  cursor: pointer;\r\n  z-index: 2;\r\n  font-size: 0.6rem;\r\n}\r\n\r\n.profileContent .block > h4 {\r\n  border-bottom: none !important;\r\n\r\n  padding-bottom: 0px !important\r\n   ;\r\n}\r\n\r\n.leftNav .userSetting ul.lnUl li > a {\r\n  border-bottom: 1px solid;\r\n  border-image-slice: 1;\r\n  border-width: 1px;\r\n  border-image-source: linear-gradient(to left, #1bd2f7, #c0eef7);\r\n}\r\n\r\n.signout {\r\n  background: linear-gradient(to left, #1bd2f7, #c0eef7);\r\n}\r\n@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {\r\n  .leftNav {\r\n    width: 170px;\r\n  }\r\n}\r\n\r\nli.hasSubMenu > ul li ul li > a {\r\n  padding-left: 38px !important;\r\n}\r\n\r\nli.hasSubMenu > ul li ul li > a > span,\r\nli.hasSubMenu > ul li ul li > a > i {\r\n  font-size: 0.85rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
